// 프로젝트 대시보드 — 바닐라 dcf.html #page-dashboard / dcf.js renderDashboard 이식.
import { unitShare, useT } from "../../lib/i18n";
import { fmt } from "../../lib/format";
import { useDcf } from "../../stores/dcf";
import { Button } from "../../ui/Button";

interface Props {
  onNew: () => void;
  /** 열기 성공 시 워크스페이스 뷰로 전환 */
  onOpen: () => void;
}

export default function DcfDashboard({ onNew, onOpen }: Props) {
  const { lang, t } = useT();
  const projects = useDcf((s) => s.projects);
  const openProject = useDcf((s) => s.openProject);
  const deleteProject = useDcf((s) => s.deleteProject);

  return (
    <div className="dashboard">
      <div className="dashboard-header">
        <h2>{t("dash.title")}</h2>
        <button className="btn-new" onClick={onNew}>
          <span>+</span> New Valuation
        </button>
      </div>
      <div className="table-wrap">
        <table>
          <thead>
            <tr>
              <th>{t("col.company")}</th>
              <th>{t("col.val_date")}</th>
              <th>{t("col.status")}</th>
              <th>{t("col.pps")}</th>
              <th>{t("col.updated")}</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {projects.length === 0 ? (
              <tr className="empty-row">
                <td colSpan={6}>{t("dash.empty")}</td>
              </tr>
            ) : (
              projects.map((p) => (
                <tr key={p.id}>
                  <td>
                    <strong>{p.name}</strong>
                  </td>
                  <td>{p.date || "—"}</td>
                  <td>
                    <span className={`status-badge ${p.pps ? "status-done" : "status-wip"}`}>
                      {p.pps ? t("status.done") : t("status.wip")}
                    </span>
                  </td>
                  <td style={{ fontFamily: "var(--mono)" }}>
                    {p.pps ? fmt(p.pps) + unitShare(lang) : "—"}
                  </td>
                  <td>{(p.updatedAt || "").slice(0, 10)}</td>
                  <td style={{ whiteSpace: "nowrap" }}>
                    <button
                      className="open-btn"
                      onClick={() => {
                        if (openProject(p.id)) onOpen();
                      }}
                    >
                      {t("dash.open")}
                    </button>
                    <Button
                      variant="del"
                      title={t("dash.del")}
                      onClick={() => {
                        if (confirm("이 프로젝트를 삭제할까요?")) deleteProject(p.id);
                      }}
                    >
                      ✕
                    </Button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
